import React from 'react';
import { IconProps } from '.';

type RemovePromoIconProps = {} & IconProps;

export const RemovePromoIcon: React.FC<RemovePromoIconProps> = ({
  width = 10,
  height = 10,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 9 10"
    >
      <path
        fill="#222427"
        d="M.207 9.003a.202.202 0 01-.142-.055.19.19 0 01-.008-.279L7.97.726a.218.218 0 01.296-.009.19.19 0 01.008.28L.361 8.94a.214.214 0 01-.154.063z"
      ></path>
      <path
        fill="#222427"
        d="M8.125 9.003a.221.221 0 01-.154-.063L.057 1A.19.19 0 01.065.723.218.218 0 01.361.73l7.914 7.943a.19.19 0 01-.008.28.226.226 0 01-.142.05z"
      ></path>
    </svg>
  );
};
